import { ScreenSizes } from '@interfaces/index';
import { useTheme } from '@mui/material';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    selectionContainer: {
      width: '100%',
      position: 'relative',
    },
    selection: {
      position: 'absolute',
      content: '""',
      inset: 0,
      padding: '0 8px 0 20px',
      // '& .MuiSvgIcon-root': {
      //   color: `${colors.white} !important`,
      // },
      // '& .MuiInputBase-root': {
      // [`@media screen and (orientation:landscape)
      // and (max-device-height: 760px)
      // and (max-device-width: 1180px)`]: {
      //   width: '100%',

      //   '& p': {
      //     fontSize: 14,
      //   },
      // },
      // },
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        padding: '0 2px 0 14px',
      },
      // [`@media screen and (orientation:landscape)
      //   and (max-device-height: 760px)
      //   and (max-device-width: 1180px)`]: {
      //   '& svg': {
      //     width: '20px !important',
      //     height: '20px !important',
      //   },
      // },
    },
  };
};
